import React from 'react';
import { isNil } from 'lodash';

interface EmbedViewProps {
  embedCode: string;
}

export function EmbedView(props: EmbedViewProps) {
  const youtubeHosts = ['www.youtube.com', 'youtube.com'];
  const vimeoHost = 'vimeo.com';

  let code = props.embedCode;

  if (isNil(props.embedCode)) {
    code = '';
  }

  if (props.embedCode?.toLowerCase().trim().startsWith('http')) {
    try {
      const domain = new URL(props.embedCode);
      const hostname = domain.hostname;
      let embedUrl = props.embedCode;
      if (youtubeHosts.includes(hostname.toLowerCase())) {
        /* Using searchParams, get the parameter keys from the url and delete other params(list, index etc.) except 'v' param */
        const params = new URLSearchParams(domain.search);
        params.forEach((value, key) => {
          if (key !== 'v') {
            domain.searchParams.delete(key);
          }
        });
        embedUrl = domain.href.replace('/watch?v=', '/embed/');
      } else if (hostname === vimeoHost) {
        embedUrl = embedUrl.replace('vimeo.com', 'player.vimeo.com/video');
      }
      code = `<iframe src=${embedUrl} class='responsive-iframe'></iframe>`;
    } catch {
      //* Just swallow the error for invalid url
    }
  }

  const isIframe = code.toLowerCase().trim().startsWith('<iframe');

  return (
    <div
      className={isIframe ? 'container' : ''}
      dangerouslySetInnerHTML={{
        __html: code
      }}
    ></div>
  );
}
